import React from 'react';

function PopupOrderHistory({
  loadingOrders,
  orderError,
  orderHistory,
  getStatusText,
  onClose
}) {
  return (
    <div className="popup-order-history" onClick={(event) => event.stopPropagation()}>
      <h2 className="popup-order-history__heading">Ваши заказы за последние 3 месяца</h2>
      {loadingOrders ? (
        <p>Загрузка заказов...</p>
      ) : orderError ? (
        <p style={{ color: 'red' }}>{orderError}</p>
      ) : orderHistory.length > 0 ? (
        <ul className="popup-order-history__list">
          {orderHistory.map((order, index) => (
            order.order ? (
              <li key={index} className="popup-order-history__order">
                <div className="popup-order-history__order-info">
                  <p className="popup-order-history__order-info-item">
                    <strong>Дата:</strong> {order.order.whenCreated ? new Date(order.order.whenCreated).toLocaleString() : 'Неизвестно'}
                  </p>
                  <p className="popup-order-history__order-info-item">
                    <strong>Статус:</strong> {getStatusText(order.order.status)}
                  </p>
                  <p className="popup-order-history__order-info-item">
                    <strong>Сумма:</strong> {order.order.sum ? `${order.order.sum} ₽` : 'Не указано'}
                  </p>
                </div>
                <ul className="popup-order-history__dishs">
                  {order.order.items?.length > 0 ? (
                    order.order.items.map((item, itemIndex) => (
                      <li key={itemIndex} className="popup-order-history__dish">
                        {item.product?.name || 'Неизвестный товар'} x {item.amount || 1}
                      </li>
                    ))
                  ) : (
                    <li className="popup-order-history__dish">
                      Заказ не был подтвержден, список блюд удален.
                    </li>
                  )}
                </ul>
              </li>
            ) : (
              <li key={index} style={{ color: 'red' }}>
                Ошибка: нет данных о заказе
              </li>
            )
          ))}
        </ul>
      ) : (
        <p>Заказы не найдены</p>
      )}
      <button className="popup-order-history__close-button" onClick={onClose}></button>
    </div>
  );
}

export default PopupOrderHistory;
